import { Routes, Route } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { useProcessAssetsRoute, PROCESS_ASSETS_PATH } from './router';
import { READ_PROCESS_ASSETS, PUBLISH_PROCESS_ASSETS } from './constants';
import ProcessAssetsListPage from './List/ProcessAssetsListPage';
import ProcessAssetsDocumentContext from './ProcessAssetsDocumentContext';
import PublishProcessAssetPage from './publish/PublishProcessAssetPage';

const ProcessAssetsRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, publishRoute } = useProcessAssetsRoute();
  return (
    <Routes>
      <Route
        path={listRoute}
        element={
          <GlobalProtectedRoute globalPermissionToCheck={[READ_PROCESS_ASSETS]}>
            <ProcessAssetsDocumentContext>
              <ProcessAssetsListPage />
            </ProcessAssetsDocumentContext>
          </GlobalProtectedRoute>
        }
      />

      <Route
        path={publishRoute}
        element={
          <GlobalProtectedRoute globalPermissionToCheck={[PUBLISH_PROCESS_ASSETS]}>
            <ProcessAssetsDocumentContext>
              <PublishProcessAssetPage />
            </ProcessAssetsDocumentContext>
          </GlobalProtectedRoute>
        }
      />
      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

ProcessAssetsRouter.getRouterPath = () => `${PROCESS_ASSETS_PATH}/*`;

export default ProcessAssetsRouter;
